export default __webpack_public_path__ + "static/media/note-add.c0eb29a8.svg";